<template>
  <v-navigation-drawer
    v-if="currentUser"
    permanent
    :mini-variant.sync="miniVariant"
    clipped
    fixed
    app
    width="250"
    style="background: #ECF3F7;"
  >
    <v-list dense nav>
      <!-- <v-list-tile v-if="!setupMode">
        <v-list-tile-action>
          <router-link to="/dashboard">
            <v-icon class="primary--text">dashboard</v-icon>
          </router-link>
        </v-list-tile-action>
        <v-list-tile-content>
          <router-link to="/dashboard">
            <v-list-tile-title>Dashboard</v-list-tile-title>
          </router-link>
        </v-list-tile-content>
      </v-list-tile> -->

      <v-list-item
        v-if="!$store.getters.isSetupModeItemsCompleted"
        v-ripple
        class="v-list-item--hovered"
        :class="{'v-list-item--active': $route.path === '/setup-checklist'}"
      >
        <v-list-item-icon>
          <router-link to="/setup-checklist">
            <v-icon class="primary--text">list</v-icon>
          </router-link>
        </v-list-item-icon>
        <v-list-item-content>
          <router-link to="/setup-checklist">
            <v-list-item-title>Setup checklist</v-list-item-title>
          </router-link>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        class="pa-5"
        v-if="!mobilizeMode && !mobilizev2Mode"
      >
        <v-list-item-content>
          <v-btn
            to="campaign/new"
            color="primary"
            class="mini-hidden"
          >
            <v-icon left dark>add</v-icon>
            Create new campaign &nbsp;&nbsp;
          </v-btn>
        </v-list-item-content>
      </v-list-item>

      <!-- <v-divider/> -->

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="grey--text">Campaigns</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

        <v-list-item
          v-ripple
          value="true"
          v-for="item in shortcutsList"
          :key="item.title"
          class="v-list-item--hovered"
          :class="{'v-list-item--active': item.feature === 'sidebar_mobilizev2_only' ? $route.path.includes(item.path.split('/')[2]) : $route.path === item.path}"
        >
          <v-list-item-icon v-if="!item.feature || features[item.feature]">
            <a v-if="item.absolutePath" :href="item.absolutePath" target="_blank">
              <v-icon v-html="item.icon" class="primary--text" />
            </a>
            <router-link
              v-else-if="!setupMode"
              :to="{ path: item.path, params: item.params }"
            >
              <v-icon v-html="item.icon" class="primary--text" />
            </router-link>
            <v-icon
              v-else
              v-html="item.icon"
            />
          </v-list-item-icon>
          <v-list-item-content v-if="!item.feature || features[item.feature]">
            <a v-if="item.absolutePath" :href="item.absolutePath" target="_blank">
              <v-list-item-title v-text="item.title" />
            </a>
            <router-link
              v-else-if="!setupMode"
              :to="{ path: item.path, params: item.params }"
            >
              <v-list-item-title v-text="item.title" />
            </router-link>
            <v-list-item-title
              v-else
              class="grey--text"
              v-text="item.title"
            />
          </v-list-item-content>
        </v-list-item>
      <!-- <v-divider /> -->

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="grey--text">Tools</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <div
        v-for="item in leftMenuBottom"
        :key="item.title"
      >
        <v-list-item
          v-ripple
          value="true"
          v-if="!item.feature || features[item.feature]"
          class="v-list-item--hovered"
          :class="{'v-list-item--active': item.path === $route.path}"
        >
          <v-list-item-icon>
            <a v-if="item.absolutePath" :href="item.absolutePath" target="_blank">
              <v-icon v-html="item.icon" class="primary--text" />
            </a>
            <router-link
              v-else-if="!setupMode"
              :to="{ path: item.path, params: item.params }"
            >
              <v-icon v-html="item.icon" class="primary--text" />
            </router-link>
            <v-icon
              v-else
              v-html="item.icon"
              class="primary--text"
            />
          </v-list-item-icon>
          <v-list-item-content>
            <a v-if="item.absolutePath" :href="item.absolutePath" target="_blank">
              <v-list-item-title v-text="item.title" />
            </a>
            <router-link
              v-else-if="item.setupModeAllow || !setupMode"
              :to="{ path: item.path, params: item.params }"
            >
              <v-list-item-title v-text="item.title" />
            </router-link>
            <v-list-item-title
              v-else
              class="grey--text"
              v-text="item.title"
            />
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  export default {
    name: 'sidebar-component',
    data () {
      return {
        leftMenuShortcuts: [
          {
            icon: 'photo_library',
            path: '/campaigns-new',
            title: 'All'
          },
          {
            icon: 'credit_card',
            path: '/campaigns/fundraising',
            title: 'Fundraising'
          },
          {
            icon: 'person_add',
            path: '/campaigns/volunteer-outreach',
            title: 'Acquisition'
          },
          {
            icon: 'record_voice_over',
            path: '/campaigns/voter-outreach',
            title: 'Persuasion'
          },
          {
            icon: 'event',
            path: '/campaigns/events',
            title: 'Events'
          }
        ],
        leftMenuBottom: [
          {
            icon: 'people',
            setupModeAllow: true,
            path: '/audiences',
            title: 'Audiences',
            feature: ''
          },
          {
            icon: 'add_photo_alternate',
            setupModeAllow: true,
            path: '/creative',
            title: 'Creative',
            feature: 'sidebar_tag_creative'
          },
          {
            icon: 'alarm',
            setupModeAllow: false,
            path: '/goals',
            title: 'Goals',
            feature: 'sidebar_goals'
          },
          // {
          //   icon: 'important_devices',
          //   setupModeAllow: false,
          //   path: '/landing-pages',
          //   title: 'Landing pages',
          //   feature: 'sidebar_landing_pages'
          // },
          {
            icon: 'settings',
            setupModeAllow: true,
            path: '/admin',
            title: 'Admin',
            feature: 'sidebar_admin'
          }],
          mobilizeShortcuts: [
            {
              icon: 'group_add',
              path: '/ads/local-events',
              title: 'Event ads',
              feature: 'sidebar_mobilize_only'
            },
            {
              icon: 'book',
              path: '/ads/helpers',
              title: 'Ad helpers',
              feature: 'sidebar_mobilize_only'
            },
            {
              icon: 'insert_chart',
              setupModeAllow: false,
              absolutePath: 'http://analytics.outfox.ai/',
              path: '',
              title: 'Reporting',
              feature: null
            }
          ],
          mobilizev2Shortcuts: [
            {
              icon: 'dashboard',
              path: '/mobilizev2',
              title: 'Dashboard',
              feature: 'sidebar_mobilizev2_only'
            },
            {
              icon: 'poll',
              path: '/mobilizev2/campaigns',
              title: 'Ad campaigns',
              feature: 'sidebar_mobilizev2_only'
            },
            {
              icon: 'group_add',
              path: '/mobilizev2/events',
              title: 'Events',
              feature: 'sidebar_mobilizev2_only'
            },
            {
              icon: 'photo',
              path: '/mobilizev2/image-templates',
              title: 'Image Templates',
              feature: 'sidebar_mobilizev2_only'
            },
            {
              icon: 'subject',
              path: '/mobilizev2/text-templates',
              title: 'Text Templates',
              feature: 'sidebar_mobilizev2_only'
            },
            {
              icon: 'add_to_photos',
              path: '/mobilizev2/create-templates',
              title: 'Create Templates',
              feature: 'sidebar_mobilizev2_only'
            },
            {
              icon: 'insert_chart',
              setupModeAllow: false,
              absolutePath: 'http://analytics.outfox.ai/',
              path: '',
              title: 'Reporting',
              feature: null
            }
          ],
          mobilizev2DemoShortcuts: [
            {
              icon: 'group_add',
              path: '/mobilizev2/demo/events',
              title: 'Events',
              feature: 'sidebar_mobilizev2demo_only'
            },
            {
              icon: 'photo',
              path: '/mobilizev2/demo/image-templates',
              title: 'Image Templates',
              feature: 'sidebar_mobilizev2demo_only'
            },
            {
              icon: 'subject',
              path: '/mobilizev2/demo/text-templates',
              title: 'Text Templates',
              feature: 'sidebar_mobilizev2demo_only'
            },
            {
              icon: 'add_to_photos',
              path: '/mobilizev2/demo/create-templates',
              title: 'Create Templates',
              feature: 'sidebar_mobilizev2demo_only'
            },
            {
              icon: 'insert_chart',
              setupModeAllow: false,
              absolutePath: 'http://analytics.outfox.ai/',
              path: '',
              title: 'Reporting',
              feature: null
            }
          ],
        right: true,
        rightDrawer: false
      }
    },
    props: {
      miniVariant: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      currentUser () {
        return this.$store.getters.getCurrentUser
      },
      features () {
        const version = this.$store.getters.getAppVersion
        return this.$store.getters.getFeatures[version]
      },
      selectedAdvertiser () {
        return this.currentUser.firebaseAccount.selectedAdvertiser
      },
      setupMode () {
        const setupMode = this.$store.getters.getSetupMode
        return setupMode ? setupMode.status : false
      },
      mobilizeMode () {
        const version = this.$store.getters.getAppVersion
        if (version === 'mobilize') {
          return true
        } else {
          return false
        }
      },
      mobilizev2Mode () {
        const version = this.$store.getters.getAppVersion
        if (version === 'mobilizev2') {
          return true
        } else {
          return false
        }
      },
      mobilizev2DemoMode () {
        const version = this.$store.getters.getAppVersion
        if (version === 'mobilizev2demo') {
          return true
        } else {
          return false
        }
      },
      shortcutsList () {
        if (this.mobilizeMode) {
          return this.mobilizeShortcuts
        } else if (this.mobilizev2Mode) {
          return this.mobilizev2Shortcuts
        } else if (this.mobilizev2DemoMode) {
          return this.mobilizev2DemoShortcuts
        } else {
          return this.leftMenuShortcuts
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .v-list--dense .v-list-item .v-list-item__title {
    font-size: 14px !important;
    font-weight: 500 !important;
  }
  .v-list-item--hovered:hover {
    background: rgba(0,0,0,0.075);
  }
  .v-list-item--active {
    background: rgba(0,0,0,0.075);
    user-select: none;
  }
  .mini-hidden {
    font-size: 12px !important;
  }
</style>
